// extracted by mini-css-extract-plugin
module.exports = {"tabs":"tabs_tabs__3nLou"};